import { useParams  } from "react-router-dom";

const useGetZone = () => {
  const allowedzones = ['south', 'north', 'laguna'];
  const { zone } = useParams();
  let outzone;

  if (zone === undefined) outzone = sessionStorage.vtzone !== undefined ? sessionStorage.vtzone : 'south';
  else {
    outzone = allowedzones.includes(zone) ? zone : sessionStorage.vtzone !== undefined ? sessionStorage.vtzone : 'south';
  }

  sessionStorage.vtzone = outzone
  return outzone;
};

export default useGetZone;